/* eslint-disable */
import { useContext } from 'react';
import { AppContext, useAppContext } from './auth/useAppContext';

export function useStandardCall() {
  const appContext = useContext(AppContext);

  function _callStandardCall(apiRoute, rq, callback, method = 'POST') {
    // query string
    let qs = '';
    if (method === 'GET' && rq) {
      qs = (apiRoute.indexOf('?') === -1 ? '?' : '&') + 
           new URLSearchParams(rq).toString();
    }

    return fetch(`${process.env.REACT_APP_REST_URL}${apiRoute}${qs}`, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        api_key: TheApp.CurrentContext.app.jsApiKey,
        access_token: appContext.userSession
          ? appContext.userSession.Bearer
          : null,
        lng: appContext.locale
      },
      method: method,
      credentials: 'include',
      body: method !== 'GET' && rq ? JSON.stringify(rq) : null
    })
    .then((response) => response.json())
    .then((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .catch((error) => {
      const errorResponse = {
        StatusCode: 503,
        Message: 'ServiceUnavailable',
        Exception: error,
        Success: false
      };
      if (callback) {
        callback(errorResponse);
      }
      throw error;
    });
  }

  return {
    post: (apiRoute, rq, callback) =>
      _callStandardCall(apiRoute, rq, callback, 'POST'),
    get: (apiRoute, rq, callback) =>
      _callStandardCall(apiRoute, rq, callback, 'GET'),
    del: (apiRoute, rq, callback) =>
      _callStandardCall(apiRoute, rq, callback, 'DELETE')
  };
}
